var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4787_3275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.4615 9.19727C41.9082 9.88692 40.2389 10.351 38.4857 10.5637C40.2711 9.48731 41.6504 7.79219 42.2949 5.76836C40.6191 6.76094 38.7629 7.48281 36.7906 7.86953C35.2115 6.1873 32.9621 5.13672 30.4678 5.13672C25.6854 5.13672 21.8053 9.0168 21.8053 13.7992C21.8053 14.476 21.8826 15.1398 22.0309 15.7715C14.8314 15.4105 8.45059 11.9559 4.17734 6.71582C3.42969 7.99844 3.0043 9.48731 3.0043 11.0793C3.0043 14.0828 4.53184 16.7318 6.85859 18.2852C5.43418 18.24 4.1 17.8533 2.9334 17.2023C2.9334 17.241 2.9334 17.2732 2.9334 17.3119C2.9334 21.5078 5.91758 25.0076 9.88144 25.8068C9.15313 26.0066 8.39258 26.1098 7.59981 26.1098C7.03906 26.1098 6.49766 26.0582 5.96914 25.9551C7.07129 29.3904 10.2682 31.9041 14.058 31.9686C11.0996 34.2953 7.36133 35.6746 3.30078 35.6746C2.59824 35.6746 1.91504 35.6359 1.23828 35.5586C5.0668 38.0143 9.62363 39.4451 14.5156 39.4451C30.4484 39.4451 39.1625 26.2451 39.1625 14.8047C39.1625 14.4244 39.1561 14.0506 39.1367 13.6768C40.8318 12.465 42.3014 10.9375 43.4615 9.19727Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4787_3275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.9,
    height: 42.9,
    fill: "white",
    transform: "translate(0.800781)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.0d355ad272819d2602eed29ac1248fc2.svg";
export { ForwardRef as ReactComponent };